<template>
    <div class="button">
        <input style="display: none;" type="file" id="OCR" accept="image/*" name="OCR" @change="(e) => { fileOCR(e.target.files, e) }" />
        <label for="OCR" class="image_label">{{title}}</label>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'OCR_recognition',
    props: {
        title: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            aiResultData: "",
        }
    },
    methods: {
        fileOCR(files, e) {
            const file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            formData.append('user', "abc-123");
            // 发送上传请求
            axios.post(
                `${window.global_config.AI_CHAT_URL}/v1/files/upload`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${window.global_config.AI_API.OCR_API_KEY}`,
                    },
                }
            ).then((res) => {
                console.log('上传成功:', res);
                this.analysisOCR(res.data.id)
            }).catch((error) => {
                e.target.value = "";
                console.error('上传失败:', error);
            });
        },
        async analysisOCR(fileId) {
            this.isError = false;
            const params = {
                response_mode: "streaming",
                "inputs": {
                    "file": {
                        "transfer_method": "local_file",
                        "upload_file_id": fileId,
                        "type": "image"
                    },
                    "type": this.name
                },
                user: "abc-123"
            }
            // 显示加载提示
            const loading = this.$loading({
                lock: true,
                text: 'AI识别中...',
                background: 'rgba(255, 255, 255, 0.4)'
            });
            const response = await fetch(`${window.global_config.AI_CHAT_URL}/v1/workflows/run`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${window.global_config.AI_API.OCR_ORDER_KEY}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    loading.close();
                    if (this.isError) {
                        if (this.aiResultData.indexOf('[tongyi] Incorrect model credentials provided, please check and try again.') !== -1) {
                            this.$message.error('模型鉴权失败：API密钥配置错误，请联系管理员')
                        } else {
                            this.$message.error(this.aiResultData)
                        }
                        return;
                    }
                    // 处理OCR结果数据，将字符串转换为数组
                    const processedData = this.processOCRResults(this.aiResultData);
                    console.log('处理后的数组数据:', processedData);
                    this.$emit('OCRResult', processedData);
                    break;
                }
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop();
                lines.forEach(line => {
                    if (line.startsWith('data:')) {
                        const data = line.substring(5).trim();
                        if (data) {
                            try {
                                const parsedData = JSON.parse(data)
                                if (parsedData.event == 'text_chunk' && !this.isError) {
                                    this.aiResultData = parsedData.data.text
                                } else {
                                    if (parsedData.data.error != null) {
                                        this.isError = true;
                                        this.aiResultData = parsedData.data.error;
                                    }
                                }
                            } catch (e) {
                                console.error('解析数据失败:', e);
                            }
                        }
                    }
                });
            }
        },
        // 处理OCR识别结果,将字符串格式转换为数组
        processOCRResults(resultString) {
            if (!resultString || typeof resultString !== 'string') {
                return [];
            }

            try {
                // 如果结果是JSON数组格式的字符串,直接解析
                if (resultString.trim().startsWith('[')) {
                    return JSON.parse(resultString);
                }

                // 如果是多行字典格式(每行以'- {'开头),按行分割并解析
                const lines = resultString.split('\n').filter(line => line.trim());
                const resultArray = [];

                for (let line of lines) {
                    // 去除前缀 '- ' 或其他标记
                    let cleanLine = line.replace(/^[-*]\s*/, '').trim();

                    // 尝试解析为JSON对象
                    if (cleanLine.startsWith('{') && cleanLine.endsWith('}')) {
                        try {
                            // Python字典转JSON: 将单引号替换为双引号
                            // 注意:需要处理值中包含单引号的情况
                            let jsonStr = cleanLine
                                .replace(/'/g, '"')  // 单引号转双引号
                                .replace(/None/g, 'null')  // Python的None转null
                                .replace(/True/g, 'true')  // Python的True转true
                                .replace(/False/g, 'false');  // Python的False转false

                            const obj = JSON.parse(jsonStr);
                            resultArray.push(obj);
                        } catch (e) {
                            console.warn('无法解析行数据:', line, e);
                            // 尝试更复杂的转换处理
                            try {
                                const obj = this.pythonDictToJson(cleanLine);
                                if (obj) {
                                    resultArray.push(obj);
                                }
                            } catch (e2) {
                                console.error('二次解析也失败:', line, e2);
                            }
                        }
                    }
                }

                return resultArray;
            } catch (error) {
                console.error('处理OCR结果失败:', error);
                return [];
            }
        },
        // 更强大的Python字典转JSON方法
        pythonDictToJson(pyStr) {
            try {
                // 处理嵌套的单引号和特殊字符
                let result = pyStr
                    .replace(/None/g, 'null')
                    .replace(/True/g, 'true')
                    .replace(/False/g, 'false');

                // 使用正则表达式更安全地替换引号
                // 匹配键和字符串值中的单引号
                result = result.replace(/:\s*'([^']*)'/g, ': "$1"');  // 值部分的单引号
                result = result.replace(/'([^']*)'\s*:/g, '"$1":');    // 键部分的单引号

                return JSON.parse(result);
            } catch (e) {
                console.error('Python字典转换失败:', e);
                return null;
            }
        }
    },
}
</script>

<style scoped>
.button {
    display: inline-block;
    font-size: 0;
    margin: 0;
    padding: 0;
}
.image_label {
    display: inline;
    cursor: pointer;
    padding: 6px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}
</style>